export default __webpack_public_path__ + "img/Thanks.f321b3e5.png";